import { useEffect } from "react";
import { useCartStore } from "../../store/CartStore";
import { useNonUserCartStore } from "../../store/NonUserCartStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import useAuthStore from "../../store/AuthStore";
const CartIcon = ({ onClick }) => {
  const { user } = useAuthStore();
  const { totalItems, fetchCart } = user
    ? useCartStore()
    : useNonUserCartStore();
  useEffect(() => {
    if (user) {
      fetchCart();
    }
  }, [user, fetchCart]);
  return (
    <div
      className="relative cursor-pointer"
      onClick={onClick}
      title="View your cart"
    >
      <FontAwesomeIcon
        icon={faShoppingCart}
        className="text-white hover:text-orange-300 text-xl md:text-2xl transition"
      />

      {totalItems > 0 && (
        <span className="absolute -top-2 -right-2 bg-orange-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full shadow-md">
          {totalItems}
        </span>
      )}
    </div>
  );
};

export default CartIcon;
